export default __webpack_public_path__ + "static/media/element_60.3240e880.webp";